module.exports = __webpack_public_path__ + "static/media/tick.93907862.svg";